import { call, put, takeLatest, select } from 'redux-saga/effects';
import { SendApiRequest } from 'src/api';
import { apiRoutes } from 'src/api/routes';
import {
    fetchContractors,
    contractorsFetched,
    contractorsFetchFailed,
    getContractorMapFilters,
} from '../contractorMap';
import { showToastAction } from '../ui';

function* fetchContractorsEffect() {
    try {
        const filters = yield select(getContractorMapFilters);
        const body = {};

        if (filters.province) body.province = filters.province;
        if (filters.city) body.city = filters.city;
        if (filters.skills && filters.skills.length)
            body.skills = filters.skills;
        if (filters.subSkills && filters.subSkills.length)
            body.subSkills = filters.subSkills;
        if (filters.approval) body.approval = filters.approval;
        if (filters.onboardingStep)
            body.onboardingStep = filters.onboardingStep;
        if (filters.postalCode) body.postalCode = filters.postalCode;
        if (filters.radius) body.radius = filters.radius;
        if (filters.search) body.search = filters.search;
        if (filters.freeInFuture) body.freeInFuture = true;

        const response = yield call(SendApiRequest, {
            url: apiRoutes.mapContractorSearch,
            method: 'POST',
            body,
        });
        yield put(contractorsFetched(response));
    } catch (e) {
        yield put(contractorsFetchFailed());
        yield put(
            showToastAction({
                type: 'danger',
                text: 'Failed to load contractors for map',
            }),
        );
    }
}

export const contractorMapSagas = [
    takeLatest(fetchContractors.type, fetchContractorsEffect),
];
